
import { useTranslation } from 'react-i18next';
import { HeroBackground, Questions, Section } from 'components';
import { SUPPORT_IMG } from 'constants/app';
import { Contact, Footer } from 'components';

const FaqPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeroBackground image={SUPPORT_IMG}>
                <Section hero={true} title={t('faq.title')}>
                    <Questions />
                </Section>
            </HeroBackground>
            <Contact />
            <Footer />
        </>
    );
}

export default FaqPage;